/**
 * # WARNING
 *
 * This is a publicly exposed API used by external services. Change with caution!
 * */
export class AnimatedCreativeAdApi {
    constructor(_animatedCreative) {
        this._animatedCreative = _animatedCreative;
        console.debug('[AdApi] constructed');
    }
    play() {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.play();
    }
    pause() {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.pause();
    }
    stop() {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.stop();
    }
    seek(time) {
        var _a;
        (_a = this._animatedCreative.animator) === null || _a === void 0 ? void 0 : _a.seek(time);
    }
    mute(muted) {
        var _a;
        (_a = this._animatedCreative.renderer) === null || _a === void 0 ? void 0 : _a.mute_m(muted);
    }
    renderDynamicProperties(dynamicData) {
        return this._animatedCreative.updateDynamicPropertyElements_m(dynamicData);
    }
}
